// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label-text {
  display: flex;
  text-align: center;
  flex-direction: column;
  font-size: 1rem;
  font-weight: 600;
}

.input-text {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
}

.cold {
  margin-left: 20px;
  margin-right: 20px;
}

.modal-query {
  background-color: green;
  color: white;
}

.loading {
  background-color: "transparent";
  backface-visibility: hidden;
}

.contbg {
  background-color: whitesmoke;
}

.form-control:focus {
  outline: none !important;
  box-shadow: none !important;
}

.kbl-form {
  background: #ececec;
  border-radius: 10px;
  transition: 0.3s;
  border: solid 1px #dedede !important;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.15) !important;
}
.kbl-form::placeholder {
  color: #a1a1a1;
}
.kbl-form:hover {
  background: #f5f5f5;
}
.kbl-form:focus {
  background: #FDFFFC !important;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.15) !important;
}

.kbl-btn-1 {
  background: #217ed5;
  border-radius: 10px;
  border-color: #217ed5;
  font-weight: 500;
  color: white;
  transition: 0.3s;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2) !important;
}
.kbl-btn-1:focus {
  box-shadow: 0px 0px 0px 2px rgba(33, 126, 213, 0.48);
}
.kbl-btn-1.disabled {
  pointer-events: none;
  background: #aeaeae !important;
  border-color: #aeaeae !important;
}
.kbl-btn-1:hover {
  background: #1472ca;
  border-color: #1472ca;
  color: white;
}
.kbl-btn-1:focus {
  background: #1472ca !important;
  border-color: #1472ca !important;
  color: white;
}

.kbl-btn-2 {
  background: rgba(239, 48, 48, 0.822);
  border-radius: 10px;
  border-color: rgba(239, 48, 48, 0.822);
  font-weight: 500;
  color: white;
  transition: 0.3s;
  box-shadow: 0 0.0625rem 0.125rem rgba(0, 0, 0, 0.2) !important;
}
.kbl-btn-2:focus {
  box-shadow: 0px 0px 0px 2px rgba(239, 48, 48, 0.48);
}
.kbl-btn-2.disabled {
  pointer-events: none;
  background: #aeaeae !important;
  border-color: #aeaeae !important;
}
.kbl-btn-2:hover {
  background: rgba(243, 16, 16, 0.87);
  border-color: rgba(243, 16, 16, 0.87);
  color: white;
}
.kbl-btn-2:focus {
  background: rgba(243, 16, 16, 0.87) !important;
  border-color: rgba(243, 16, 16, 0.87) !important;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/pages/Interactome/Interactome.scss","webpack://./src/scss/globals.scss","webpack://./src/scss/colors.scss"],"names":[],"mappings":"AAKA;EACI,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAJJ;;AAQA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AALJ;;AAQA;EACI,iBAAA;EACA,kBAAA;AALJ;;AAOA;EACI,uBAAA;EACA,YAAA;AAJJ;;AAOA;EAEI,+BAAA;EACA,2BAAA;AALJ;;AAQA;EACI,4BAAA;AALJ;;AAQA;EACI,wBAAA;EACA,2BAAA;AALJ;;AAQE;EACE,mBAAA;EACA,mBC9CY;ED+CZ,gBAAA;EACA,oCAAA;EACA,+DAAA;AALJ;AAOI;EACE,cAAA;AALN;AAQI;EACE,mBAAA;AANN;AASI;EACE,8BAAA;EACA,+DAAA;AAPN;;AAYE;EACE,mBEjEQ;EFkER,mBClES;EDmET,qBEnEQ;EFoER,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,8DAAA;AATJ;AAWI;EAEE,oDAAA;AATN;AAYI;EACE,oBAAA;EACA,8BAAA;EACA,gCAAA;AAVN;AAYI;EACI,mBEzDS;EF0DT,qBE1DS;EF2DT,YAAA;AAVR;AAaM;EACE,8BAAA;EACA,gCAAA;EACA,YAAA;AAXR;;AAiBE;EACE,oCE/FO;EFgGP,mBCpGS;EDqGT,sCEjGO;EFkGP,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,8DAAA;AAdJ;AAgBI;EAEE,mDAAA;AAdN;AAiBI;EACE,oBAAA;EACA,8BAAA;EACA,gCAAA;AAfN;AAiBI;EACI,mCExFQ;EFyFR,qCEzFQ;EF0FR,YAAA;AAfR;AAkBM;EACE,8CAAA;EACA,gDAAA;EACA,YAAA;AAhBR","sourcesContent":["@import '../../scss/colors.scss';\n@import '../../scss/globals';\n\n\n\n.label-text {\n    display: flex;\n    text-align: center;\n    flex-direction: column;\n    font-size: 1rem;\n    font-weight: 600;\n}\n\n\n.input-text {\n    display: flex;\n    flex-direction: column;\n    border-radius: 10px;\n}\n\n.cold {\n    margin-left: 20px;\n    margin-right:20px;\n}\n.modal-query{\n    background-color: green;\n    color: white;\n}\n\n.loading {\n    \n    background-color: 'transparent';\n    backface-visibility: hidden;    \n}\n\n.contbg{\n    background-color: whitesmoke;\n}\n\n.form-control:focus {\n    outline: none!important;\n    box-shadow: none!important;\n  }\n  \n  .kbl-form {\n    background: #ececec;\n    border-radius: $border-radius;\n    transition: 0.3s;\n    border: solid 1px #dedede!important;\n    box-shadow: 0 .0625rem .125rem rgba(0, 0, 0, 0.15)!important;\n  \n    &::placeholder {\n      color: #a1a1a1;\n    }\n  \n    &:hover {\n      background: #f5f5f5;\n    }\n  \n    &:focus {\n      background: $white!important;\n      box-shadow: 0 .0625rem .125rem rgba(0, 0, 0, 0.15)!important;\n    }\n  }\n\n\n  .kbl-btn-1 {\n    background: $palette-1;\n    border-radius: $radius-btn;\n    border-color: $palette-1;\n    font-weight: 500;\n    color: white;\n    transition: 0.3s;\n    box-shadow: 0 .0625rem .125rem rgba(0, 0, 0, 0.2)!important;\n\n    &:focus {\n      -webkit-box-shadow: 0px 0px 0px 2px rgba($palette-1,0.48);\n      box-shadow: 0px 0px 0px 2px rgba($palette-1,0.48);\n    }\n\n    &.disabled {\n      pointer-events: none;\n      background: #aeaeae!important;\n      border-color: #aeaeae!important;\n    }\n    &:hover {\n        background: $palette-1-dark;\n        border-color: $palette-1-dark;\n        color: white;\n      }\n  \n      &:focus {\n        background: $palette-1-dark!important;\n        border-color: $palette-1-dark!important;\n        color: white;\n      }\n  }\n\n\n\n  .kbl-btn-2 {\n    background: $palette-4;\n    border-radius: $radius-btn;\n    border-color: $palette-4;\n    font-weight: 500;\n    color: white;\n    transition: 0.3s;\n    box-shadow: 0 .0625rem .125rem rgba(0, 0, 0, 0.2)!important;\n\n    &:focus {\n      -webkit-box-shadow: 0px 0px 0px 2px rgba($palette-4,0.48);\n      box-shadow: 0px 0px 0px 2px rgba($palette-4,0.48);\n    }\n\n    &.disabled {\n      pointer-events: none;\n      background: #aeaeae!important;\n      border-color: #aeaeae!important;\n    }\n    &:hover {\n        background: $palette-4-dark;\n        border-color: $palette-4-dark;\n        color: white;\n      }\n  \n      &:focus {\n        background: $palette-4-dark!important;\n        border-color: $palette-4-dark!important;\n        color: white;\n      }\n  }\n","$border-radius: 10px;\n$big-radius: 16px;\n$radius-btn: 10px;\n$nav-radius: 12px;\n\n$fw-light: 300;\n$fw-medium: 400;\n$fw-heavy: 500;\n","$black: #011627;\n$white: #FDFFFC;\n$palette-1: #217ed5;\n// $palette-2: #074ba5;\n$palette-2: #52796F;\n$palette-3: #FF9F1C;\n$palette-4:rgba(239, 48, 48, 0.822);\n$palette-5: #748b80;\n// 5fa15a\n// eab271\n// 1d2d44d0\n$nav-outline: #eff;\n$nav-outline-hvr: rgba(#217ed5,.4);\n\n$text-ghost:rgb(0, 0, 0);\n$text-light: #717171;\n$text-main: #393939;\n$text-hard: #212121;\n\n$color-light-grey: #c9c9c9;\n\n$palette-1-v-light: #abeef0;\n\n$palette-1-bg: #e2fcfc;\n$palette-2-bg: #ffe4eb;\n\n$palette-1-light: #1890ff;\n$palette-2-light: #ffe9ee;\n\n$palette-1-dark: #1472ca;\n$palette-2-dark: #ab1236;\n$palette-3-dark: #bb781c;\n$palette-4-dark:rgba(243, 16, 16, 0.87);\n\n$chip-bg: #def5ff;\n$chip-font: #036778;\n\n$palette-1-pastel: #a9fafc;\n\n$nav-back : #96c4a0;\n// 9ecf7d\n// f08585\n// 7dce82\n// rgb(152, 171, 196)"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
